// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/entitlements.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, extDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import { file_vitesse_v1_common } from "./common_pb.js";
/**
 * Describes the file vitesse/v1/entitlements.proto.
 */
export const file_vitesse_v1_entitlements = /*@__PURE__*/ fileDesc("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", [file_google_protobuf_descriptor, file_vitesse_v1_common]);
/**
 * Describes the message vitesse.v1.CapValue.
 * Use `create(CapValueSchema)` to create a new message.
 */
export const CapValueSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 0);
/**
 * Describes the message vitesse.v1.StringList.
 * Use `create(StringListSchema)` to create a new message.
 */
export const StringListSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 1);
/**
 * Describes the message vitesse.v1.Grant.
 * Use `create(GrantSchema)` to create a new message.
 */
export const GrantSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 2);
/**
 * Describes the message vitesse.v1.EntitlementsRecord.
 * Use `create(EntitlementsRecordSchema)` to create a new message.
 */
export const EntitlementsRecordSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 3);
/**
 * Describes the message vitesse.v1.Lapse.
 * Use `create(LapseSchema)` to create a new message.
 */
export const LapseSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 4);
/**
 * Describes the message vitesse.v1.FeatureConfig.
 * Use `create(FeatureConfigSchema)` to create a new message.
 */
export const FeatureConfigSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 5);
/**
 * Describes the message vitesse.v1.OrgRef.
 * Use `create(OrgRefSchema)` to create a new message.
 */
export const OrgRefSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 6);
/**
 * Describes the message vitesse.v1.GetFeatureConfigRequest.
 * Use `create(GetFeatureConfigRequestSchema)` to create a new message.
 */
export const GetFeatureConfigRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 7);
/**
 * Describes the message vitesse.v1.WatchFeatureConfigRequest.
 * Use `create(WatchFeatureConfigRequestSchema)` to create a new message.
 */
export const WatchFeatureConfigRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 8);
/**
 * Describes the message vitesse.v1.GrantReply.
 * Use `create(GrantReplySchema)` to create a new message.
 */
export const GrantReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 9);
/**
 * Describes the message vitesse.v1.GetFeatureConfigReply.
 * Use `create(GetFeatureConfigReplySchema)` to create a new message.
 */
export const GetFeatureConfigReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 10);
/**
 * Describes the message vitesse.v1.AuthoredGrants.
 * Use `create(AuthoredGrantsSchema)` to create a new message.
 */
export const AuthoredGrantsSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 11);
/**
 * Describes the message vitesse.v1.SessionPlan.
 * Use `create(SessionPlanSchema)` to create a new message.
 */
export const SessionPlanSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 12);
/**
 * Describes the message vitesse.v1.SubscribeSessionEntitlementsRequest.
 * Use `create(SubscribeSessionEntitlementsRequestSchema)` to create a new message.
 */
export const SubscribeSessionEntitlementsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 13);
/**
 * Describes the message vitesse.v1.PermissionSeed.
 * Use `create(PermissionSeedSchema)` to create a new message.
 */
export const PermissionSeedSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 14);
/**
 * Describes the message vitesse.v1.Requires.
 * Use `create(RequiresSchema)` to create a new message.
 */
export const RequiresSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_entitlements, 15);
/**
 * Capability is the closed set of gated capabilities. It lives in the contract,
 * not in one service, so plans validates a matrix against exactly the list the
 * executors enforce — by construction rather than by discipline.
 *
 * The wire key is the enum name with its CAPABILITY_ prefix stripped and
 * lowercased: CAPABILITY_CLOUD_RECORDING ⇒ "cloud_recording". Keys are plain and
 * readable on purpose (a hash is undebuggable in a record, and a typo hashes
 * perfectly into a valid-looking key that denies silently).
 *
 * A key is NEVER derived from the tier granting it: several tiers may carry the
 * same capability, and moving one between tiers must not rename it — that would
 * turn a pricing decision into a migration of every stored record.
 *
 * plans REFUSES TO SIGN a matrix containing a key outside this enum, so a typo
 * is caught at the single component that authors, which is the only place that
 * can still fix it. That is what makes absent-means-denied safe: an absent key
 * was deliberately omitted, because a wrong one could not have been signed.
 *
 * Adding a capability is a reviewed contract change; buf breaking guards it.
 *
 * @generated from enum vitesse.v1.Capability
 */
export var Capability;
(function (Capability) {
    /**
     * @generated from enum value: CAPABILITY_UNSPECIFIED = 0;
     */
    Capability[Capability["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CAPABILITY_CLOUD_RECORDING = 1;
     */
    Capability[Capability["CLOUD_RECORDING"] = 1] = "CLOUD_RECORDING";
    /**
     * @generated from enum value: CAPABILITY_CLOUD_HISTORIAN = 2;
     */
    Capability[Capability["CLOUD_HISTORIAN"] = 2] = "CLOUD_HISTORIAN";
    /**
     * @generated from enum value: CAPABILITY_MARKETPLACE = 3;
     */
    Capability[Capability["MARKETPLACE"] = 3] = "MARKETPLACE";
    /**
     * @generated from enum value: CAPABILITY_PROGRAM_BACKUP = 4;
     */
    Capability[Capability["PROGRAM_BACKUP"] = 4] = "PROGRAM_BACKUP";
    /**
     * Premium auto-quarantine of a network side (IT/OT) on an IDS threat, gated in
     * the access-point captive portal. Fail-closed: a free or unknown org never
     * auto-locks.
     *
     * @generated from enum value: CAPABILITY_NETWORK_SEGMENTATION = 5;
     */
    Capability[Capability["NETWORK_SEGMENTATION"] = 5] = "NETWORK_SEGMENTATION";
    /**
     * Graduated (choice: basic|flows|full). THE row most surfaces hang off, and it
     * spans every UI — the same value decides how much the gateway app, the fleet UI
     * and the AI UI may show. basic = what exists and what it is doing now; flows =
     * the surfaces that explain why (logs, vitals, faster polling); full = everything.
     *
     * @generated from enum value: CAPABILITY_TELEMETRY = 6;
     */
    Capability[Capability["TELEMETRY"] = 6] = "TELEMETRY";
    /**
     * Graduated (members: the event kinds this org receives at all). Not a boolean:
     * an IDS alert, an OTA report and a claim record are different products. The
     * gateway filters the stream by this set, so an org never receives an event kind
     * it did not buy — the UI is never asked to hide one.
     *
     * @generated from enum value: CAPABILITY_EVENTS = 7;
     */
    Capability[Capability["EVENTS"] = 7] = "EVENTS";
    /**
     * Graduated (choice: none|profiles|per_user). Who may author permissions:
     * none = role defaults only; profiles = one admin + one member profile;
     * per_user = profiles plus a per-user override.
     *
     * @generated from enum value: CAPABILITY_RBAC = 8;
     */
    Capability[Capability["RBAC"] = 8] = "RBAC";
    /**
     * Connecting external systems. Granted plus per-ARCHETYPE ceilings, because
     * "1 DB" and "1 DB + 1 backend" are limits on different kinds.
     *
     * @generated from enum value: CAPABILITY_IT_INTEGRATIONS = 9;
     */
    Capability[Capability["IT_INTEGRATIONS"] = 9] = "IT_INTEGRATIONS";
    /**
     * The AI plane itself — may this org reach the assistant at all. The whole
     * ai-worker surface hangs off it: /api/llm/*, AiAdmin, /agent/*, the voice
     * handshake.
     *
     * A row of its own rather than inferring "bought AI" from a storage allowance
     * being non-zero. That inference holds only while every AI tier happens to sell
     * storage; the day a tier sells storage-less AI, or AI-less storage, the gate
     * answers a question nobody asked it — and it answers it SILENTLY, because a
     * paywall that reads the wrong row still returns a perfectly ordinary 403.
     *
     * @generated from enum value: CAPABILITY_AI_CONSOLE = 10;
     */
    Capability[Capability["AI_CONSOLE"] = 10] = "AI_CONSOLE";
    /**
     *
     * THE FLOOR: does this organization have a plan at all?
     *
     * Every other capability answers "did they buy this FEATURE". This one answers the question
     * underneath all of them, and it exists because the answer used to be "no gate at all": a caller
     * with the right role but no plan reached symbols, controllers, values, models, video and the
     * fleet, because those procedures declared a permission and nothing else. Permission-only means
     * open on every tier, including none.
     *
     * Deliberately ONE capability rather than a finer gate per surface. The rule being encoded is
     * binary — an org with no plan gets the AI plane and the billing page and nothing else — and
     * spelling that as thirty-eight separate feature capabilities would state it thirty-eight times
     * and let it drift in thirty-eight places. Finer gates still layer on top: a procedure may
     * declare both this and a feature capability, and both must hold.
     *
     * @generated from enum value: CAPABILITY_PLATFORM = 11;
     */
    Capability[Capability["PLATFORM"] = 11] = "PLATFORM";
    /**
     *
     * THE SURFACE THAT MUST WORK BEFORE ANYTHING IS BOUGHT — and it is gated anyway.
     *
     * Every tier grants this, including the free floor, so the check always passes. That is the point:
     * the alternative was `public:`, which does not run the gate at all, and a procedure that skips the
     * mechanism is a procedure nobody notices when the mechanism changes. Paying the lookup means this
     * surface is exercised by the same code path as everything else rather than sitting beside it.
     *
     * What belongs here is narrow: discovering which plan you are on, and reaching the page that sells
     * one. If a procedure would still make sense to deny, it wants a real capability instead.
     *
     * @generated from enum value: CAPABILITY_ONBOARDING = 12;
     */
    Capability[Capability["ONBOARDING"] = 12] = "ONBOARDING";
    /**
     *
     * CAPABILITIES THAT WERE SOLD BEFORE THEY COULD BE REQUIRED.
     *
     * A gate can only require what this enum names — Catalog() is derived from it — so a row that
     * exists in the plans matrix and NOT here is unenforceable by construction. Not "nobody got
     * round to it": there is no constant for a call site to reference, so the requirement cannot be
     * expressed at all, and the capability is a line on a price list.
     *
     * Seventeen rows were in that state. These eleven are the ones whose FEATURE exists, so a gate
     * on them is a real refusal. Deliberately omitted: cloud_anomaly, edge_anomaly,
     * functional_analysis, ids, telemetry_5g, iiot_devices — gating a feature nobody has built
     * refuses callers who were never going to arrive, which reads as enforcement and is theatre.
     * They stay sold-but-ungateable until the thing they name exists, and that is the honest state.
     *
     * Adding an enum member grants nothing and requires nothing on its own. It gives the services
     * that own these surfaces a constant to gate against; the refusal is theirs to write.
     *
     * @generated from enum value: CAPABILITY_AI_STORAGE_BYTES = 13;
     */
    Capability[Capability["AI_STORAGE_BYTES"] = 13] = "AI_STORAGE_BYTES";
    /**
     * @generated from enum value: CAPABILITY_AI_DASHBOARDS = 14;
     */
    Capability[Capability["AI_DASHBOARDS"] = 14] = "AI_DASHBOARDS";
    /**
     * @generated from enum value: CAPABILITY_AI_RULES_ADMIN = 15;
     */
    Capability[Capability["AI_RULES_ADMIN"] = 15] = "AI_RULES_ADMIN";
    /**
     * @generated from enum value: CAPABILITY_AI_USAGE_DASHBOARD = 16;
     */
    Capability[Capability["AI_USAGE_DASHBOARD"] = 16] = "AI_USAGE_DASHBOARD";
    /**
     * @generated from enum value: CAPABILITY_CUSTOM_PROMPT = 17;
     */
    Capability[Capability["CUSTOM_PROMPT"] = 17] = "CUSTOM_PROMPT";
    /**
     * @generated from enum value: CAPABILITY_CUSTOM_SPECIALISTS = 18;
     */
    Capability[Capability["CUSTOM_SPECIALISTS"] = 18] = "CUSTOM_SPECIALISTS";
    /**
     * @generated from enum value: CAPABILITY_CUSTOM_MCP = 19;
     */
    Capability[Capability["CUSTOM_MCP"] = 19] = "CUSTOM_MCP";
    /**
     * @generated from enum value: CAPABILITY_DREAMING = 20;
     */
    Capability[Capability["DREAMING"] = 20] = "DREAMING";
    /**
     * @generated from enum value: CAPABILITY_VOICE_MODE = 21;
     */
    Capability[Capability["VOICE_MODE"] = 21] = "VOICE_MODE";
    /**
     * @generated from enum value: CAPABILITY_FLEET_MANAGER = 22;
     */
    Capability[Capability["FLEET_MANAGER"] = 22] = "FLEET_MANAGER";
    /**
     * @generated from enum value: CAPABILITY_SAML_SSO = 23;
     */
    Capability[Capability["SAML_SSO"] = 23] = "SAML_SSO";
    /**
     * Moved OUT of the deliberately-ungateable set the moment each gained a real consumer:
     * ids grades what fleet records may carry (fleet-control strips below `detection`), and
     * functional_analysis sells the assistant's program-reading tools (stripped at the AI worker's
     * edge). Neither gate resolves through this enum today — both read the capability by its string
     * key from the grant — but a constant existing is what lets a future ANNOTATED procedure require
     * them, and the parity guard's question is "can this be required", not "is it".
     *
     * @generated from enum value: CAPABILITY_IDS = 24;
     */
    Capability[Capability["IDS"] = 24] = "IDS";
    /**
     * @generated from enum value: CAPABILITY_FUNCTIONAL_ANALYSIS = 25;
     */
    Capability[Capability["FUNCTIONAL_ANALYSIS"] = 25] = "FUNCTIONAL_ANALYSIS";
})(Capability || (Capability = {}));
/**
 * Describes the enum vitesse.v1.Capability.
 */
export const CapabilitySchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_entitlements, 0);
/**
 * Limit is the closed set of numeric parameters an executor enforces. In a grant
 * these ride as "<capability>.<limit>" keys (e.g. "cloud_recording.max_bytes").
 * Same prefix-strip-and-lowercase rule: LIMIT_MAX_BYTES ⇒ "max_bytes".
 *
 * An UNBOUNDED cap omits its key from the derived limits — absent limit means
 * unlimited, matching the catalog's uncapped semantics.
 *
 * @generated from enum vitesse.v1.Limit
 */
export var Limit;
(function (Limit) {
    /**
     * @generated from enum value: LIMIT_UNSPECIFIED = 0;
     */
    Limit[Limit["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: LIMIT_RETENTION_DAYS = 1;
     */
    Limit[Limit["RETENTION_DAYS"] = 1] = "RETENTION_DAYS";
    /**
     * @generated from enum value: LIMIT_MAX_BYTES = 2;
     */
    Limit[Limit["MAX_BYTES"] = 2] = "MAX_BYTES";
    /**
     * Video retention is expressed in hours (1 hr / 1 month), so days would round a
     * sold value away.
     *
     * @generated from enum value: LIMIT_RETENTION_HOURS = 3;
     */
    Limit[Limit["RETENTION_HOURS"] = 3] = "RETENTION_HOURS";
    /**
     * Per-archetype integration ceilings — the three shapes the integrations service
     * supports. Separate keys because a tier sells them separately.
     *
     * @generated from enum value: LIMIT_MAX_TABLE = 4;
     */
    Limit[Limit["MAX_TABLE"] = 4] = "MAX_TABLE";
    /**
     * @generated from enum value: LIMIT_MAX_TOPIC = 5;
     */
    Limit[Limit["MAX_TOPIC"] = 5] = "MAX_TOPIC";
    /**
     * @generated from enum value: LIMIT_MAX_ENDPOINT = 6;
     */
    Limit[Limit["MAX_ENDPOINT"] = 6] = "MAX_ENDPOINT";
    /**
     * Generic counts, for the rows that are simply "how many".
     *
     * @generated from enum value: LIMIT_MAX_USERS = 7;
     */
    Limit[Limit["MAX_USERS"] = 7] = "MAX_USERS";
    /**
     * @generated from enum value: LIMIT_MAX_DASHBOARDS = 8;
     */
    Limit[Limit["MAX_DASHBOARDS"] = 8] = "MAX_DASHBOARDS";
    /**
     * Monthly egress ceiling. Counts the customer's DATA PLANE only — never
     * heartbeats, OTA downloads, or safety traffic like IDS, or a fleet under attack
     * would throttle itself exactly when it must not.
     *
     * @generated from enum value: LIMIT_MAX_BANDWIDTH_BYTES = 9;
     */
    Limit[Limit["MAX_BANDWIDTH_BYTES"] = 9] = "MAX_BANDWIDTH_BYTES";
})(Limit || (Limit = {}));
/**
 * Describes the enum vitesse.v1.Limit.
 */
export const LimitSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_entitlements, 1);
/**
 * Lifecycle of one capability for one org. Executors react to the value and never
 * decide timing.
 *
 * @generated from enum vitesse.v1.Lifecycle
 */
export var Lifecycle;
(function (Lifecycle) {
    /**
     * never entitled — inactive, nothing to purge
     *
     * @generated from enum value: LIFECYCLE_UNSPECIFIED = 0;
     */
    Lifecycle[Lifecycle["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * granted — execute normally, enforce the limits
     *
     * @generated from enum value: LIFECYCLE_ACTIVE = 1;
     */
    Lifecycle[Lifecycle["ACTIVE"] = 1] = "ACTIVE";
    /**
     * lapsed, in the window — FREEZE: no new writes, keep + serve data
     *
     * @generated from enum value: LIFECYCLE_GRACE = 2;
     */
    Lifecycle[Lifecycle["GRACE"] = 2] = "GRACE";
    /**
     * window elapsed — the executor PURGES this org+capability's data
     *
     * @generated from enum value: LIFECYCLE_EXPIRED = 3;
     */
    Lifecycle[Lifecycle["EXPIRED"] = 3] = "EXPIRED";
})(Lifecycle || (Lifecycle = {}));
/**
 * Describes the enum vitesse.v1.Lifecycle.
 */
export const LifecycleSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_entitlements, 2);
/**
 * @generated from enum vitesse.v1.Permission
 */
export var Permission;
(function (Permission) {
    /**
     * @generated from enum value: PERMISSION_UNSPECIFIED = 0;
     */
    Permission[Permission["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * ─── Reads ──────────────────────────────────────────────────────────────
     *
     * Every one is a MEMBER DEFAULT, so nothing a person can do today stops
     * working. Naming them is the point: an action with no permission cannot be
     * revoked from one user without a code change, so "everyone in the org may
     * read the PLC program" was not a policy — it was the absence of one.
     *
     * These are also where plan TIERING will attach. What a telemetry grade buys is
     * how deep into a controller you may look, so the ladder — symbols, then
     * properties, then programs, then logs, then history — is expressed as levels on
     * these reads. The levels are NOT set here: adding one would take access away
     * from an org that has it today, which is a pricing decision and belongs with the
     * plans matrix, not with this change.
     *
     * @generated from enum value: PERMISSION_GATEWAY_VIEW = 6;
     */
    Permission[Permission["GATEWAY_VIEW"] = 6] = "GATEWAY_VIEW";
    /**
     * @generated from enum value: PERMISSION_CONTROLLER_VIEW = 22;
     */
    Permission[Permission["CONTROLLER_VIEW"] = 22] = "CONTROLLER_VIEW";
    /**
     * @generated from enum value: PERMISSION_PLUGIN_VIEW = 23;
     */
    Permission[Permission["PLUGIN_VIEW"] = 23] = "PLUGIN_VIEW";
    /**
     * @generated from enum value: PERMISSION_SYMBOL_VIEW = 53;
     */
    Permission[Permission["SYMBOL_VIEW"] = 53] = "SYMBOL_VIEW";
    /**
     * @generated from enum value: PERMISSION_MODEL_VIEW = 14;
     */
    Permission[Permission["MODEL_VIEW"] = 14] = "MODEL_VIEW";
    /**
     * @generated from enum value: PERMISSION_INTEGRATION_VIEW = 33;
     */
    Permission[Permission["INTEGRATION_VIEW"] = 33] = "INTEGRATION_VIEW";
    /**
     * @generated from enum value: PERMISSION_CAMERA_VIEW = 42;
     */
    Permission[Permission["CAMERA_VIEW"] = 42] = "CAMERA_VIEW";
    /**
     * @generated from enum value: PERMISSION_NETWORK_VIEW = 103;
     */
    Permission[Permission["NETWORK_VIEW"] = 103] = "NETWORK_VIEW";
    /**
     * @generated from enum value: PERMISSION_PROGRAM_VIEW = 110;
     */
    Permission[Permission["PROGRAM_VIEW"] = 110] = "PROGRAM_VIEW";
    /**
     * @generated from enum value: PERMISSION_HISTORY_READ = 111;
     */
    Permission[Permission["HISTORY_READ"] = 111] = "HISTORY_READ";
    /**
     * Reads that disclose more than the list they sit next to, split so they can be
     * withheld on their own.
     *
     * A model's SCXML and a controller's program source are the customer's process
     * IP — the thing a competitor would want — and seeing that a model EXISTS is a
     * different disclosure from reading what it does. Watching a camera is likewise
     * not the same as knowing one is mounted.
     *
     * @generated from enum value: PERMISSION_MODEL_SOURCE_VIEW = 15;
     */
    Permission[Permission["MODEL_SOURCE_VIEW"] = 15] = "MODEL_SOURCE_VIEW";
    /**
     * @generated from enum value: PERMISSION_PROGRAM_SOURCE_VIEW = 112;
     */
    Permission[Permission["PROGRAM_SOURCE_VIEW"] = 112] = "PROGRAM_SOURCE_VIEW";
    /**
     * @generated from enum value: PERMISSION_CAMERA_WATCH = 43;
     */
    Permission[Permission["CAMERA_WATCH"] = 43] = "CAMERA_WATCH";
    /**
     * @generated from enum value: PERMISSION_INTEGRATION_READ = 34;
     */
    Permission[Permission["INTEGRATION_READ"] = 34] = "INTEGRATION_READ";
    /**
     * @generated from enum value: PERMISSION_INTEGRATION_BROWSE = 35;
     */
    Permission[Permission["INTEGRATION_BROWSE"] = 35] = "INTEGRATION_BROWSE";
    /**
     * Labels and descriptions. Unguarded writes today, annotated "personalization" —
     * and an empty label is a DELETE, batched to a whole catalog, which the
     * annotation's reasoning never covered.
     *
     * @generated from enum value: PERMISSION_SYMBOL_ANNOTATE = 54;
     */
    Permission[Permission["SYMBOL_ANNOTATE"] = 54] = "SYMBOL_ANNOTATE";
    /**
     * @generated from enum value: PERMISSION_CONTROLLER_ANNOTATE = 24;
     */
    Permission[Permission["CONTROLLER_ANNOTATE"] = 24] = "CONTROLLER_ANNOTATE";
    /**
     * Gateway
     *
     * @generated from enum value: PERMISSION_GATEWAY_CLAIM = 1;
     */
    Permission[Permission["GATEWAY_CLAIM"] = 1] = "GATEWAY_CLAIM";
    /**
     * @generated from enum value: PERMISSION_GATEWAY_UNCLAIM = 2;
     */
    Permission[Permission["GATEWAY_UNCLAIM"] = 2] = "GATEWAY_UNCLAIM";
    /**
     * @generated from enum value: PERMISSION_GATEWAY_REMOVE = 3;
     */
    Permission[Permission["GATEWAY_REMOVE"] = 3] = "GATEWAY_REMOVE";
    /**
     * @generated from enum value: PERMISSION_GATEWAY_RENAME = 4;
     */
    Permission[Permission["GATEWAY_RENAME"] = 4] = "GATEWAY_RENAME";
    /**
     * @generated from enum value: PERMISSION_GATEWAY_UPDATE = 5;
     */
    Permission[Permission["GATEWAY_UPDATE"] = 5] = "GATEWAY_UPDATE";
    /**
     * Model
     *
     * @generated from enum value: PERMISSION_MODEL_CREATE = 10;
     */
    Permission[Permission["MODEL_CREATE"] = 10] = "MODEL_CREATE";
    /**
     * @generated from enum value: PERMISSION_MODEL_DELETE = 11;
     */
    Permission[Permission["MODEL_DELETE"] = 11] = "MODEL_DELETE";
    /**
     * @generated from enum value: PERMISSION_MODEL_EDIT = 12;
     */
    Permission[Permission["MODEL_EDIT"] = 12] = "MODEL_EDIT";
    /**
     * @generated from enum value: PERMISSION_MODEL_EXECUTE = 13;
     */
    Permission[Permission["MODEL_EXECUTE"] = 13] = "MODEL_EXECUTE";
    /**
     * Controller
     *
     * @generated from enum value: PERMISSION_CONTROLLER_CREATE = 20;
     */
    Permission[Permission["CONTROLLER_CREATE"] = 20] = "CONTROLLER_CREATE";
    /**
     * @generated from enum value: PERMISSION_CONTROLLER_DELETE = 21;
     */
    Permission[Permission["CONTROLLER_DELETE"] = 21] = "CONTROLLER_DELETE";
    /**
     *
     * UPDATE is its own permission because it is its own blast radius.
     *
     * UpdateController was gated on controller:create, and its payload is the
     * connection form of an EXISTING controller — host, port, credentials. So
     * "may add a controller" could not be granted without also granting "may
     * repoint a live production PLC at a different box", which is not the same
     * risk and is not what an admin thinks they are handing out. Adding is
     * additive and reversible; repointing silently moves a running line's data
     * source.
     *
     * @generated from enum value: PERMISSION_CONTROLLER_UPDATE = 25;
     */
    Permission[Permission["CONTROLLER_UPDATE"] = 25] = "CONTROLLER_UPDATE";
    /**
     * Integration
     *
     * @generated from enum value: PERMISSION_INTEGRATION_CREATE = 30;
     */
    Permission[Permission["INTEGRATION_CREATE"] = 30] = "INTEGRATION_CREATE";
    /**
     * @generated from enum value: PERMISSION_INTEGRATION_DELETE = 31;
     */
    Permission[Permission["INTEGRATION_DELETE"] = 31] = "INTEGRATION_DELETE";
    /**
     * @generated from enum value: PERMISSION_INTEGRATION_WRITE = 32;
     */
    Permission[Permission["INTEGRATION_WRITE"] = 32] = "INTEGRATION_WRITE";
    /**
     * Camera
     *
     * @generated from enum value: PERMISSION_CAMERA_PUBLISH = 40;
     */
    Permission[Permission["CAMERA_PUBLISH"] = 40] = "CAMERA_PUBLISH";
    /**
     * @generated from enum value: PERMISSION_CAMERA_RECORD = 41;
     */
    Permission[Permission["CAMERA_RECORD"] = 41] = "CAMERA_RECORD";
    /**
     * Symbol
     *
     * @generated from enum value: PERMISSION_SYMBOL_LOCK = 50;
     */
    Permission[Permission["SYMBOL_LOCK"] = 50] = "SYMBOL_LOCK";
    /**
     * @generated from enum value: PERMISSION_SYMBOL_WRITE = 51;
     */
    Permission[Permission["SYMBOL_WRITE"] = 51] = "SYMBOL_WRITE";
    /**
     * @generated from enum value: PERMISSION_SYMBOL_CONFIG = 52;
     */
    Permission[Permission["SYMBOL_CONFIG"] = 52] = "SYMBOL_CONFIG";
    /**
     *
     * Polling priority is a PERMISSION as well as a plan, because it persists.
     *
     * SetPollingPriority was gated on the telemetry plan alone and exempted from
     * the "a mutation needs a permission" rule with the reason that it is "a
     * VIEWPORT HINT, not persisted config… persists nothing". The proto's own
     * documentation on that RPC says the opposite three lines from where the
     * exemption was written: the plugin "persists the priority flag to local plugin
     * storage so it survives restart" and republishes the SymbolDescriptor. It is
     * durable state, and the whole-controller form of it touches every symbol on
     * the controller — nobody's viewport is 500k rows.
     *
     * A capability is not authorization: with the plan alone, every member of a
     * paying org may pin native-push subscriptions against a finite per-CPU vendor
     * budget, and no admin can revoke it because there is nothing to revoke.
     * member_default, because it IS ordinary operational work — naming it is what
     * makes it revocable from one user without a code change.
     *
     * @generated from enum value: PERMISSION_SYMBOL_PRIORITY = 55;
     */
    Permission[Permission["SYMBOL_PRIORITY"] = 55] = "SYMBOL_PRIORITY";
    /**
     * Dashboard
     *
     * @generated from enum value: PERMISSION_DASHBOARD_CREATE = 60;
     */
    Permission[Permission["DASHBOARD_CREATE"] = 60] = "DASHBOARD_CREATE";
    /**
     * @generated from enum value: PERMISSION_DASHBOARD_DELETE = 61;
     */
    Permission[Permission["DASHBOARD_DELETE"] = 61] = "DASHBOARD_DELETE";
    /**
     *
     * HAND A BOARD OUT — its own key, because the act it authorizes leaves the org.
     *
     * Sharing was gated on `dashboard:create`, which reads as reasonable and answers the
     * wrong question. Creating a board puts a drawing somewhere only org members can
     * reach; sharing one mints a bearer credential that a person with no account, no role
     * and no membership can open. Those are not the same risk, and folding them into one
     * key means an organisation that wants boards built but not published has nothing to
     * take away — every author is a publisher, and the only way back is to stop them
     * authoring.
     *
     * member_default, matching `dashboard:create` deliberately: the person who composes a
     * board is the person who hands it out, and taking that away from everyone by default
     * would break the workflow the share feature exists for. What the split buys is that it
     * can now be taken away from ONE user, or from a whole role, without touching their
     * ability to build. The ceiling is unchanged either way — a share freezes a snapshot of
     * what the sharer could already read, so this widens nobody's reach, it only decides
     * who may re-issue their own.
     *
     * @generated from enum value: PERMISSION_DASHBOARD_SHARE = 125;
     */
    Permission[Permission["DASHBOARD_SHARE"] = 125] = "DASHBOARD_SHARE";
    /**
     *
     * MAY ADD TO WHAT BOARDS CAN BE MADE OF — which is not the same as making one.
     *
     * A widget is a drawing program stored against the org and placeable on any of its boards. The
     * obvious shortcut is to gate authoring on `dashboard:create`, and it is wrong in both
     * directions: it would let anyone who can make a board add executable code to the catalogue, and
     * it would force a widget author to also hold the board-writing verbs — so the specialist that is
     * meant to write a widget and hand the name on could place its own work with no second pair of
     * eyes. Its own key keeps the two jobs separable, which is the whole reason they are two roles.
     *
     * NOT member_default: writing code that runs in every viewer's browser is an administrator's
     * grant, even though the sandbox is what actually contains it.
     *
     * @generated from enum value: PERMISSION_WIDGET_AUTHOR = 117;
     */
    Permission[Permission["WIDGET_AUTHOR"] = 117] = "WIDGET_AUTHOR";
    /**
     *
     * May a widget author — a person or an agent acting as one — see and place widgets published by
     * organisations other than its own and Vitesse? Third-party code runs in every viewer's browser,
     * sandboxed; an organisation that wants only its own and Vitesse's on its boards withholds this.
     * Granted by default: the shelf is the point of a marketplace.
     *
     * @generated from enum value: PERMISSION_WIDGET_THIRD_PARTY = 126;
     */
    Permission[Permission["WIDGET_THIRD_PARTY"] = 126] = "WIDGET_THIRD_PARTY";
    /**
     * Org administration — both non-delegatable.
     *
     * @generated from enum value: PERMISSION_BILLING_MANAGE = 70;
     */
    Permission[Permission["BILLING_MANAGE"] = 70] = "BILLING_MANAGE";
    /**
     * @generated from enum value: PERMISSION_MEMBER_MANAGE = 71;
     */
    Permission[Permission["MEMBER_MANAGE"] = 71] = "MEMBER_MANAGE";
    /**
     * AI
     *
     * @generated from enum value: PERMISSION_AI_USE = 80;
     */
    Permission[Permission["AI_USE"] = 80] = "AI_USE";
    /**
     * Reads, separated from the writes above them. Seeing the org's AI
     * configuration, its transcripts, its memories and its audit trail are four
     * different disclosures, and a customer will want them granted apart.
     *
     * @generated from enum value: PERMISSION_AI_CONFIG_VIEW = 85;
     */
    Permission[Permission["AI_CONFIG_VIEW"] = 85] = "AI_CONFIG_VIEW";
    /**
     * @generated from enum value: PERMISSION_AI_TRANSCRIPT_VIEW = 86;
     */
    Permission[Permission["AI_TRANSCRIPT_VIEW"] = 86] = "AI_TRANSCRIPT_VIEW";
    /**
     * Reading OTHER people's threads, as distinct from your own.
     *
     * Your own conversations are yours to read, so that is a member default. Reading
     * a colleague's is a separate act and a separate grant — the shape every
     * comparable product ships, where the ORGANISATION can reach the data through an
     * admin or compliance role and no ordinary member can. Without the split there is
     * only one answer for both questions, and it was "yes".
     *
     * @generated from enum value: PERMISSION_AI_TRANSCRIPT_VIEW_OWN = 94;
     */
    Permission[Permission["AI_TRANSCRIPT_VIEW_OWN"] = 94] = "AI_TRANSCRIPT_VIEW_OWN";
    /**
     * @generated from enum value: PERMISSION_AI_MEMORY_VIEW = 87;
     */
    Permission[Permission["AI_MEMORY_VIEW"] = 87] = "AI_MEMORY_VIEW";
    /**
     *
     * WRITE A MEMORY — the agent's own verb, distinct from viewing.
     *
     * Memory was formed only after the fact, by consolidation, so an agent told "I prefer RPM" could
     * not keep it and said so. Every agent role holds this: what an assistant learns while helping is
     * worth having the next time, and "remember that" is the most ordinary request there is.
     *
     * @generated from enum value: PERMISSION_AI_MEMORY_WRITE = 124;
     */
    Permission[Permission["AI_MEMORY_WRITE"] = 124] = "AI_MEMORY_WRITE";
    /**
     *
     * THE FINDINGS LOG — what was measured, derived or proposed, dated, and never rewritten. Memory is
     * what is believed now and the dream loop revises it; a finding is what was found then, which is
     * what showing improvement over time needs.
     *
     * THREE KEYS, because three different acts. Reading the history is for every agent and person.
     * Recording an entry is an agent's verb (the data scientist's, by role) — and a member default for
     * the same reason `ai:memory:write` is: an agent's call is checked against the PERSON it runs for,
     * so a member without it would have a data scientist that cannot record what it found. Deciding —
     * accepting, closing or declining a proposal — belongs to people: `ai:finding:review` is never
     * granted to an agent role, and the RPC that uses it is not a tool, so no agent can move an entry.
     *
     * @generated from enum value: PERMISSION_AI_FINDING_VIEW = 128;
     */
    Permission[Permission["AI_FINDING_VIEW"] = 128] = "AI_FINDING_VIEW";
    /**
     * @generated from enum value: PERMISSION_AI_FINDING_WRITE = 129;
     */
    Permission[Permission["AI_FINDING_WRITE"] = 129] = "AI_FINDING_WRITE";
    /**
     * @generated from enum value: PERMISSION_AI_FINDING_REVIEW = 130;
     */
    Permission[Permission["AI_FINDING_REVIEW"] = 130] = "AI_FINDING_REVIEW";
    /**
     * @generated from enum value: PERMISSION_AI_AUDIT_VIEW = 88;
     */
    Permission[Permission["AI_AUDIT_VIEW"] = 88] = "AI_AUDIT_VIEW";
    /**
     * Signing this user in to an external MCP account. Distinct from ai:config,
     * which adds the SERVER: connecting is per-user and routine, adding a server
     * is org-shaping.
     *
     * @generated from enum value: PERMISSION_AI_MCP_CONNECT = 89;
     */
    Permission[Permission["AI_MCP_CONNECT"] = 89] = "AI_MCP_CONNECT";
    /**
     *
     * DELEGATION TO A SPECIALIST — the permission that makes a specialist able to
     * reach ANOTHER specialist rather than hold that specialist's tools itself.
     *
     * A specialist runs as a ROLE (ExpertConfig.role), so its reach is that role's
     * grants and nothing else. When one specialist calls another, the callee runs as
     * ITS OWN role — the permissions travel by pointer, not by copy, and never widen
     * the caller. That is what lets the dashboard specialist answer a program question
     * by handing it to the program specialist while never holding program access
     * itself, exactly the way a module calls another module instead of reaching into
     * its internals.
     *
     * So this grant answers one question only: MAY this role hand work to a
     * specialist at all. It cannot grant what the callee may do — the callee's role
     * already decides that — which is why delegation here accumulates no privilege.
     *
     * Not a member default: an ordinary member talks to the conversational agent,
     * and that agent's own role carries this where the product intends fan-out.
     *
     * @generated from enum value: PERMISSION_AI_SPECIALIST_SPAWN = 116;
     */
    Permission[Permission["AI_SPECIALIST_SPAWN"] = 116] = "AI_SPECIALIST_SPAWN";
    /**
     *
     * AGENTS WORKING AS A TEAM — three verbs, and the first is the gate on the other two.
     *
     * Delegation gave a run the ability to CREATE another (`ai:specialist:spawn`) and exactly one edge
     * back: a finished child's answer travelling one level up. Everything else a team does — finding
     * out who else is working, reading what one of them got to, telling one of them something — had
     * nowhere to go. These are those three, and they are separate keys because they are separate
     * disclosures: knowing an agent exists, reading everything it has thought, and putting words into
     * its prompt are three different amounts of trust.
     *
     * DISCOVER IS THE GATE. A verb addressed to "the agent called reader" is unusable to a caller that
     * cannot find out there is a reader — so read and message are, in practice, reachable only by a
     * role that also holds discover. That dependency is deliberate and is the reason discover is the
     * cheapest of the three to grant: it is the one an administrator can hand out to make a team
     * legible without making it writable.
     *
     * INSTANCE-SCOPED, like spawn, and scoped to the same thing: the specialist id. An org can say
     * "may message the program analyst, and nothing else", and a role written before scoping existed
     * holds the bare key and so covers every one of them.
     *
     * @generated from enum value: PERMISSION_AI_AGENT_DISCOVER = 118;
     */
    Permission[Permission["AI_AGENT_DISCOVER"] = 118] = "AI_AGENT_DISCOVER";
    /**
     *
     * READING ANOTHER AGENT'S WORKING NOTES.
     *
     * The heaviest of the three, because it is the only one that MOVES data: a child's whole
     * exploration becomes readable by its parent. Its own key rather than folding into
     * `ai:transcript:view` — that permission is about a PERSON reading threads through the console,
     * governed for compliance reasons, and an agent reading its own child's notes is a different
     * question with a different answer for most orgs.
     *
     * @generated from enum value: PERMISSION_AI_AGENT_READ = 119;
     */
    Permission[Permission["AI_AGENT_READ"] = 119] = "AI_AGENT_READ";
    /**
     *
     * PUTTING WORDS INTO ANOTHER AGENT'S PROMPT.
     *
     * A message is delivered at the recipient's next step boundary and is read by the model as input.
     * It is labelled as coming from a peer rather than from the person — that labelling is enforced by
     * the verb, not by this grant — but the capability to make another agent read something is still
     * its own decision, and an org that wants a team that can look and not talk now has a way to say
     * so.
     *
     * @generated from enum value: PERMISSION_AI_AGENT_MESSAGE = 120;
     */
    Permission[Permission["AI_AGENT_MESSAGE"] = 120] = "AI_AGENT_MESSAGE";
    /**
     *
     * ONE MESSAGE TO EVERY AGENT AT ONCE.
     *
     * Separate from `ai:agent:message` because it is that verb multiplied by the size of the tree, and
     * multiplication is exactly what an administrator bounding an agent's blast radius wants a
     * separate switch for: one broadcast costs every recipient a step boundary and a slice of its
     * context, so a team of twenty pays twenty times for one call.
     *
     * NOT instance-scoped, because a broadcast has no instance — scoping "send to everyone" to one
     * specialist would be a message, and that verb already exists.
     *
     * @generated from enum value: PERMISSION_AI_AGENT_BROADCAST = 121;
     */
    Permission[Permission["AI_AGENT_BROADCAST"] = 121] = "AI_AGENT_BROADCAST";
    /**
     *
     * WAKE UP UNATTENDED — park a run until later and resume it with nobody watching.
     *
     * Instance-scoped by SPECIALIST, and not a member default: sleeping until 3am and then acting is a
     * capability an org grants to a particular agent ("ai:agent:wake/data-scientist"), not something
     * every agent inherits because a person can use the assistant. Whether a tab is open is not part
     * of the question — a closed tab is not a security boundary, and this grant is.
     *
     * What the woken run may then DO is decided the ordinary way, by the owner's own role checked
     * again at wake time, so a revoked grant or a departed person stops it.
     *
     * @generated from enum value: PERMISSION_AI_AGENT_WAKE = 127;
     */
    Permission[Permission["AI_AGENT_WAKE"] = 127] = "AI_AGENT_WAKE";
    /**
     *
     * RUNNING CODE, as its own question.
     *
     * It would have been easy to gate the sandbox on the permission of whatever data it loads —
     * `history:read` for a history dataset — and that is genuinely most of the risk, because rows the
     * caller could not read are rows the sandbox cannot obtain. But it answers a different question
     * from the one an administrator is asking. "May this agent read our process history" and "may this
     * agent execute code we did not write" are separate decisions, and an org that says yes to the
     * first has not thereby said yes to the second.
     *
     * It is also the permission a capability toggle can finally stand on. `code_execution_enabled` has
     * existed in the AI config since the beginning — read, stored, defaulted and reported to the
     * browser as a capability — with nothing behind it, which is the same state `web_search_enabled`
     * was found in: every reference plumbing, none of them a gate.
     *
     * NOT instance-scoped. The scoped form of this would be "may this agent run code", which is what
     * granting it to a role already says; a per-specialist axis on top would be a second spelling of
     * the same decision.
     *
     * @generated from enum value: PERMISSION_AI_SANDBOX_RUN = 122;
     */
    Permission[Permission["AI_SANDBOX_RUN"] = 122] = "AI_SANDBOX_RUN";
    /**
     *
     * MAY THIS AGENT SPEND OUR CREDIT MAKING PICTURES.
     *
     * Its own key for the same reason `ai:sandbox:run` is: no existing grant answers it. "May this
     * agent read our history" and "may this agent generate images" are unrelated decisions, and the
     * one org that most wants a dashboard background is not necessarily the one that wants every
     * agent free to iterate on one.
     *
     * The distinguishing property is that this one COSTS MONEY per call, and unboundedly: an agent
     * that is not satisfied with a background will make another, and another. The credit ledger meters
     * it like every other model call, so nothing runs away silently — but metered is not the same as
     * authorised, and this is the authorisation.
     *
     * NOT instance-scoped, for the same reason as the sandbox: the scoped form would be "may this
     * agent generate images", which is what granting it to a role already says.
     *
     * @generated from enum value: PERMISSION_AI_IMAGE_GENERATE = 123;
     */
    Permission[Permission["AI_IMAGE_GENERATE"] = 123] = "AI_IMAGE_GENERATE";
    /**
     *
     * LAYING A REPORT OUT AS A PDF (ai_admin_render_report). Its own key rather than ai:use: the PDF is
     * a document that leaves the platform, and each render spends browser time. A member default for
     * the reason ai:finding:write is — an agent's call is checked against the person it runs for.
     *
     * @generated from enum value: PERMISSION_AI_REPORT_RENDER = 131;
     */
    Permission[Permission["AI_REPORT_RENDER"] = 131] = "AI_REPORT_RENDER";
    /**
     * @generated from enum value: PERMISSION_AI_CONFIG = 81;
     */
    Permission[Permission["AI_CONFIG"] = 81] = "AI_CONFIG";
    /**
     * @generated from enum value: PERMISSION_AI_SECRET = 82;
     */
    Permission[Permission["AI_SECRET"] = 82] = "AI_SECRET";
    /**
     * @generated from enum value: PERMISSION_AI_PURGE = 83;
     */
    Permission[Permission["AI_PURGE"] = 83] = "AI_PURGE";
    /**
     * @generated from enum value: PERMISSION_AI_EXPORT = 84;
     */
    Permission[Permission["AI_EXPORT"] = 84] = "AI_EXPORT";
    /**
     * Read the org's own audit log. Its own permission rather than folding into
     * member:manage, because a compliance or security reader legitimately needs the
     * history without any authority to change who is in the org.
     *
     * @generated from enum value: PERMISSION_AUDIT_READ = 113;
     */
    Permission[Permission["AUDIT_READ"] = 113] = "AUDIT_READ";
    /**
     * Billing reads. Separate from billing:manage, which moves money and is
     * non-delegatable: seeing what the org spends is a reporting question that an
     * operations lead may legitimately hold without any authority over the
     * subscription.
     *
     * @generated from enum value: PERMISSION_BILLING_VIEW = 91;
     */
    Permission[Permission["BILLING_VIEW"] = 91] = "BILLING_VIEW";
    /**
     * @generated from enum value: PERMISSION_BILLING_USAGE_VIEW = 92;
     */
    Permission[Permission["BILLING_USAGE_VIEW"] = 92] = "BILLING_USAGE_VIEW";
    /**
     * Accepting responsibility for a model acting autonomously. Not model:execute:
     * running a model is operational, standing behind what it does unattended is a
     * named act, and the audit trail records who.
     *
     * @generated from enum value: PERMISSION_MODEL_ARM = 93;
     */
    Permission[Permission["MODEL_ARM"] = 93] = "MODEL_ARM";
    /**
     * Marketplace — a SECOND gate, deliberately not folded into the authoring
     * permissions it sits beside.
     *
     * Installing is not "creating a model that happens to arrive pre-written". It is
     * taking control logic authored by somebody in another org and putting it in
     * front of a plant. Whether a person may author here and whether they may bring
     * in a stranger's work are different questions, and an org can reasonably answer
     * yes to the first and no to the second — the reverse of what a single
     * model:create would let it say.
     *
     * So both apply, at different boundaries: marketplace:install to take a copy at
     * all, and then the ordinary authoring permission where the copy is materialised
     * into the org (model:create for a model, dashboard:create for a widget). Nobody
     * gets a model into an org through the marketplace who could not have written one
     * by hand.
     *
     * Neither is member_default. Import is the direction risk arrives from, and
     * publish crosses the org boundary outward — the one call on the platform that
     * does. Both are grants somebody makes on purpose.
     *
     * @generated from enum value: PERMISSION_MARKETPLACE_INSTALL = 114;
     */
    Permission[Permission["MARKETPLACE_INSTALL"] = 114] = "MARKETPLACE_INSTALL";
    /**
     * Offering something outward. Kind-agnostic on purpose: it will carry dashboard
     * widgets as well as models, and the authoring permission for the KIND is what
     * says whether this person had any business with that artifact in the first
     * place.
     *
     * @generated from enum value: PERMISSION_MARKETPLACE_PUBLISH = 115;
     */
    Permission[Permission["MARKETPLACE_PUBLISH"] = 115] = "MARKETPLACE_PUBLISH";
    /**
     * Network
     *
     * @generated from enum value: PERMISSION_NETWORK_CONFIG = 100;
     */
    Permission[Permission["NETWORK_CONFIG"] = 100] = "NETWORK_CONFIG";
    /**
     * @generated from enum value: PERMISSION_NETWORK_SECURE = 101;
     */
    Permission[Permission["NETWORK_SECURE"] = 101] = "NETWORK_SECURE";
    /**
     * @generated from enum value: PERMISSION_NETWORK_RESET = 102;
     */
    Permission[Permission["NETWORK_RESET"] = 102] = "NETWORK_RESET";
})(Permission || (Permission = {}));
/**
 * Describes the enum vitesse.v1.Permission.
 */
export const PermissionSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_entitlements, 3);
/**
 * Read + watch only. There is deliberately NO write RPC — a second write path is a
 * second source of truth.
 *
 * @generated from service vitesse.v1.Entitlements
 */
export const Entitlements = /*@__PURE__*/ serviceDesc(file_vitesse_v1_entitlements, 0);
/**
 * Read-only, and deliberately stream-only.
 *
 * A tier change has to reach an open browser without a reload — a customer who
 * upgrades expects the feature to light up, and one who lapses must stop being
 * shown a control that will now fail. A unary read would leave both to a refresh.
 *
 * @generated from service vitesse.v1.SessionEntitlements
 */
export const SessionEntitlements = /*@__PURE__*/ serviceDesc(file_vitesse_v1_entitlements, 1);
/**
 * @generated from extension: vitesse.v1.PermissionSeed seed = 50002;
 */
export const seed = /*@__PURE__*/ extDesc(file_vitesse_v1_entitlements, 0);
/**
 * Every browser-reachable RPC carries this. A method with no annotation is not
 * "open by default" — it is a question nobody asked, and the gate's coverage
 * test fails the build on it.
 *
 * @generated from extension: vitesse.v1.Requires requires = 50001;
 */
export const requires = /*@__PURE__*/ extDesc(file_vitesse_v1_entitlements, 1);
//# sourceMappingURL=entitlements_pb.js.map